import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconPinComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <path d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" fill="none" stroke="currentColor" />
      <path
        d="M19.5 10.5c0 7.1-7.5 11.3-7.5 11.3s-7.5-4.2-7.5-11.3a7.5 7.5 0 1 1 15 0z"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};

IconPinComponent.displayName = 'IconPin';

const IconPin = memo(IconPinComponent);

export default IconPin;
